/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMaven = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.106 8.72c.321-.12.623-.18.964-.18.483 0 .865.06 1.126.2s.462.34.583.64c.14.3.2.68.241 1.14.02.46.04 1.04.04 1.7v6.84H22v-8.92c0-1.66-.342-2.94-1.025-3.82S19.286 5 17.96 5c-.704 0-1.427.22-2.171.64s-1.508 1-2.292 1.74C13.156 6.6 12.673 6 12.05 5.6c-.623-.4-1.326-.6-2.13-.6-.744 0-1.428.16-2.05.5-.624.34-1.267.8-1.93 1.4V5.38H2v13.7h3.94v-9.7c.281-.2.623-.38.985-.56a2.5 2.5 0 0 1 1.125-.26c.483 0 .844.06 1.126.2.261.14.462.34.603.64s.2.68.241 1.14c.02.46.04 1.04.04 1.7v6.84H14v-9.7a5.9 5.9 0 0 1 1.106-.66z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMaven as Maven };
